import * as React from 'react';
import './NewRequestBackground.scss';

export const NewRequestBackground = () => <div className="new-request__container" id="js-new-request__container"></div>;
